import { render } from "./MedicAssociationsEntry.vue?vue&type=template&id=40f99155"
import script from "./MedicAssociationsEntry.vue?vue&type=script&lang=js"
export * from "./MedicAssociationsEntry.vue?vue&type=script&lang=js"

import "./MedicAssociationsEntry.vue?vue&type=style&index=0&id=40f99155&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__